import { SvgIconProps } from '@mui/material';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { COLUMN_NAME } from '@organisms/ReportTableRow';
import AdvancedPricing from '../../public/assets/advanced-pricing.svg';
import defaultAppIcon from '../../public/assets/app-logos.svg';
import AppsAccessedIcon from '../../public/assets/apps-accessed.svg';
import AppsWithViolationsIcon from '../../public/assets/apps-with-violations.svg';
import { default as DeleteRedSvg, default as deleteIcon } from '../../public/assets/delete-red.svg';
import DownArrowInactive from '../../public/assets/down-arrow.svg';
import EnterprisePricing from '../../public/assets/enterprise-pricing.svg';
import EventsSeverityIcon from '../../public/assets/events-severity.svg';
import StandardPricing from '../../public/assets/standard-pricing.svg';
import TryAndBuyPricing from '../../public/assets/try-and-buy-pricing.svg';
import UserGroupWithViolationsIcon from '../../public/assets/usergroups-with-violations.svg';
import UserLoginIcon from '../../public/assets/userlogin-over-time.svg';
import UsersWithViolationsIcon from '../../public/assets/users-with-violations.svg';
import ViolationsByCategoryIcon from '../../public/assets/violations-by-category.svg';
import LabelWithIcon from '../_components/atoms/LabelWithIcon';
import { IDetailsListItemProps } from '../_components/molecules/DetailsListItem';
import { IDropdownOptionProps } from '../_components/molecules/Dropdown';
import { ICell } from '../_components/molecules/TableHeader';
import { IUserTableRow } from '../_components/molecules/UserTableRow';
import { ILogsTableRow } from '@organisms/LogTableRow';
import { IListPolicyResponse } from '../api-service/policy-service/PolicyService';
import { INotificationSettingsResponse, ISessionRecordingSettingsResponse } from '../api-service/settings-service/SettingsService';
import { IListUserGroupsResponse } from '../api-service/user-group-service/UserGroupService';
import { ROUTES } from './routes';
import { handleClickDropdownItem } from './test-constants';
import theme, { EXTRA_COLORS } from './theme';

//#region Interface declarations

export interface IDetailPageProps extends RouteComponentProps<MatchParams> { }

export interface IAppDetailsType {
  name: string;
  createdBy: string;
  createdOn: string;
  applicationType: string;
  appLogo: string;
  idpAppUrl?: string;
  description: string;
  appPath?: string;
  source?: string;
  externalAppUrl?: string;
  isExternalApp?: boolean | string;
}

export interface IUserDetailsType {
  id: string;
  name: string;
  email: string;
  jobTitle: string;
  // userStatus: string;
  source: string;
  password: string;
  createdBy: string;
  createdOn: string;
  description: string;
  role: string;
  skipOnboarding?: boolean;
  disableMFA?: boolean;
}

export interface IUserGroupDetails {
  name: string;
  numberOfUsers: string;
  createdBy: string;
  description: string;
  source: string;
  createdOn: string;
}

export interface IAppDetailsProps {
  appsDetails: IAppDetailsType;
  userDetails?: IUserTableRow[];
  appId: string | number;
  usergroups?: IUserGroupsAndAppsTableRow[];
  customDomain?: string;
  updateUsersOfApp?: any;
  updateUsergroupsOfApp?: any;
  domainUrls?: string;
  getAppDetails?: any;
  generateCreds?: () => void;
  removeCreds?: () => void;
  rdpAppPath?: string;
}

export interface StringToStringMap {
  [key: string]: string;
}

export interface StringToStringMapLoose {
  [key: string]: string | null;
}

export interface ICommonShade {
  main: string;
  light: string;
}

export interface ICommonShades {
  blue: ICommonShade;
  green: ICommonShade;
  orange: ICommonShade;
  red: ICommonShade;
  violet: ICommonShade;
  grey: ICommonShade;
}

export interface INestedSideNavItem {
  id: number;
  name: string;
  routeOnClick: string;
}

export interface ISideNavigationItem {
  id: number;
  name: string;
  routeOnClick?: string;
  showChildren?: boolean;
  isSelected: boolean;
  children?: Array<INestedSideNavItem>;
}

export interface IIconType extends SvgIconProps { }

export interface IDropDownMenuItem {
  text: string;
  icon?: string;
  activeIcon?: string;
  handleClick: any;
  cyId?: string;

}

export interface IApplicationEmptyState {
  handleClick: () => void;
}

export interface ITooltipValidationParams {
  id?: number;
  satisfied?: boolean;
  name?: string;
}

export interface IDropDownItem {
  id: string;
  name: string;
}
export interface IDropDownMenuItem {
  text: string;
  icon?: string;
  activeIcon?: string;
  isDanger?: boolean;
  handleClick: any;
  handleClose?: () => void;
  disabled?: boolean;
  cyId?: string;
}
export interface IDeleteUserPopUp {
  content: string;
  open: boolean;
  headingText: string;
  handleClose: () => void;
  buttonText?: string;
  onButtonClick?: (e: any) => void;
}

export interface IUserDetailsTabType {
  [key: string]: IDetailsListItemProps;
}

export interface IUserGroupDetailsTabType {
  [key: string]: IDetailsListItemProps;
}
export interface IUserGroupsAndAppsTableRow {
  name: string;
  logo?: string;
  userLength?: number;
  users?: Array<{
    id: number;
    username: string;
    profileImage?: string;
  }>;
  underTabItems?: boolean;
  handleClickStats?: () => void;
  handleClickMore?: () => void;
  handleTableRowClick?: () => void;
  target?: 'usergroup' | 'app';
  tabItemName?: string;
  showClose?: boolean;
  context?: 'app' | 'user' | 'usergroup';
  usergroupsOfApps?: string[];
}

export interface ITimeSelectionProps {
  id: number;
  timePeriod: string;
  handleClick?: () => void;
}

export interface IUserLoginOverTimeWidgetProps {
  usersLoginData: Array<{
    date: string;
    logins: number;
  }>;
  dateRange: string;
}

export interface IUserGroupsViolationsWidgetProps {
  usergroupName: string;
  violations: number;
  increment?: number;
}

export interface IMostActiveUserGroupsWidgetProps {
  usergroupName: string;
  active: number;
}

export interface IAppsViolationsWidgetProps {
  appName: string;
  violations: number;
}

export interface IAppsAccessedMostWidgetProps {
  appName: string;
  accessCount: number;
  thumbnail: string;
}

export interface IUsersViolationsWidgetProps {
  userName: string;
  violations: number;
  accessCount?: number;
}

export interface ICategoryViolationsWidgetProps {
  categoryViolationsData: Array<{
    name: string;
    violations: number;
  }>;
  title?: string;
}

export interface IEventsSeverityWidgetProps {
  name: string;
  value: number;
}

export interface ILoginFormResponse {
  authToken: string;
  username: string;
  dataSource: string;
  availableDataSources: Array<string>;
}

export interface MatchParams {
  id: string;
}

export enum FileDownloadTypes {
  csv = 'csv',
  txt = 'txt',
  json = 'json',
}

export interface IAccountSettings {
  organizationName: string;
  organizationLogo: any;
  organizationPhone: any;
  organizationPhoneCode: any;
  suppportEmailAddress: string;
  organizationAddress: string;
  language: string;
  timeZone: string;
}

export interface IAccountSettingsTab {
  languageOptions: Array<IDropdownOptionProps>;
  timeZoneOptions: Array<IDropdownOptionProps>;
}

export interface ViolationData {
  name: string;
  description: string;
  actions?: any;
  id: string;
  offset: number;
}

export interface IPolicyBuilderHeaderProps {
  policyName: string;
  target: 'Define' | 'Test';
  handlePolicyNameUpdate: (policyName: string) => void;
  editable: boolean;
  handleSave?: () => void;
  handleDeploy?: () => void;
  handleTestOrEdit?: () => void;
  onCloseClick?: () => void;
  isSaveDisabled?: boolean;
  searchData?: string[];
  savedData?: boolean;
  isSaving?: boolean;
}

export interface PolicyViolationCardsProps {
  violationsData: ViolationData[];
  onViolationClick?: (t: number) => void;
}

export interface IKeyValueObject {
  key: string;
  value: string;
}
export interface ILogSettingsResponse {
  linesPerPage: number;
  rotationPeriod: {
    time: number | null;
    diskSpace: number | null;
  };
  retentionPeriod: {
    years: number;
    months: number;
    days: number;
  };
  defaultExportFormat: Array<string>;
}

export interface ILogServerResponse {
  serverIP: string;
  port: number;
  frequencyRange: string;
  active: boolean;
}

export interface IAdministratorNotificationsDetail {
  userId: string;
  fullName: string;
  userName: string;
  notificationType?: string;
  notificationDetail: IDropDownItem[];
  notificationEnabled: boolean;
}

//#endregion Interface declarations

export const GLOBAL_LABELS = {
  REQUIRED: 'Required',
  SAVE: 'Save',
  SAVING: 'Saving...',
  CANCEL: 'Cancel',
  EDIT: 'Edit',
  OKAY: 'Ok',
  USER_GROUPS: 'User Groups',
  APPLICATIONS: 'Applications',
  POLICIES: 'Policies',
  USERS: 'Users',
  DETAILS: 'Details',
  STATS: 'Stats',
  CREDENTIALS: 'Credentials',
  CONNECT: 'Connect',
  FORGET: 'Forget'
};

export const COMMON_SHADES: ICommonShades = {
  blue: {
    main: EXTRA_COLORS.blue,
    light: EXTRA_COLORS.lightBlue,
  },
  green: {
    main: EXTRA_COLORS.green,
    light: EXTRA_COLORS.lightGreen,
  },
  orange: {
    main: EXTRA_COLORS.orange,
    light: EXTRA_COLORS.lightOrange,
  },
  red: {
    main: EXTRA_COLORS.red,
    light: EXTRA_COLORS.lightRed,
  },
  violet: {
    main: EXTRA_COLORS.violet,
    light: EXTRA_COLORS.lightViolet,
  },
  grey: {
    main: theme.palette.text.disabled,
    light: theme.palette.background.paper,
  },
};

export const SIDE_NAV = { MENU: 'MENU', DRAWER_WIDTH: 240 };

export const SIDE_NAVIGATION_ITEM_NAMES = {
  DASHBOARD: 'Dashboard',
  USER_MANAGEMENT: 'User Directory',
  APP_MANANGEMENT: 'Applications',
  POLICIES: 'Policies',
  SESSION_RECORDINGS: 'User Sessions',
  SESSION_HOSTS: 'Session Hosts',
  LOGS: 'Logs',
  SETTINGS: 'Settings',
  HELP: 'Help',
  MY_APPLICATIONS: 'My Applications',
  NOTIFICATIONS: 'Notifications',
  REPORTS: 'Reports',
};

export const END_USER_SIDE_NAVIGATION_ITEMS: Array<ISideNavigationItem> = [
  {
    id: 1,
    name: SIDE_NAVIGATION_ITEM_NAMES.MY_APPLICATIONS,
    routeOnClick: ROUTES.MY_APPLICATIONS,
    isSelected: false,
  },
];

export const ADMIN_SIDE_NAVIGATION_ITEMS: Array<ISideNavigationItem> = [
  {
    id: 7,
    name: SIDE_NAVIGATION_ITEM_NAMES.MY_APPLICATIONS,
    routeOnClick: ROUTES.MY_APPLICATIONS,
    isSelected: false,
  },
  {
    id: 1,
    name: SIDE_NAVIGATION_ITEM_NAMES.DASHBOARD,
    routeOnClick: ROUTES.DASHBOARD,
    isSelected: false,
  },
  {
    id: 5,
    name: SIDE_NAVIGATION_ITEM_NAMES.SESSION_RECORDINGS,
    routeOnClick: ROUTES.SESSION_ACTIVE,
    isSelected: false,
  },
  {
    id: 6,
    name: SIDE_NAVIGATION_ITEM_NAMES.LOGS,
    routeOnClick: ROUTES.LOGS,
    isSelected: false,
  },
  {
    id: 11,
    name: SIDE_NAVIGATION_ITEM_NAMES.REPORTS,
    routeOnClick: ROUTES.REPORTS,
    isSelected: false,
  },
  {
    id: 2,
    name: SIDE_NAVIGATION_ITEM_NAMES.USER_MANAGEMENT,
    isSelected: false,
    // showChildren: false,
    children: [
      { id: 1, name: 'User Groups', routeOnClick: ROUTES.USER_GROUPS },
      { id: 2, name: 'Users', routeOnClick: ROUTES.USERS },
    ],
  },
  {
    id: 3,
    name: SIDE_NAVIGATION_ITEM_NAMES.APP_MANANGEMENT,
    // showChildren: false,
    routeOnClick: ROUTES.APPS,
    isSelected: false,
    // children: [
    // we dont need app groups page for release 1
    // { id: 3, name: 'App Groups', routeOnClick: ROUTES.APP_GROUPS },
    // { id: 4, name: 'Apps', routeOnClick: ROUTES.APPS },
    // ],
  },
  {
    id: 4,
    name: SIDE_NAVIGATION_ITEM_NAMES.POLICIES,
    routeOnClick: ROUTES.POLICIES,
    isSelected: false,
  },
  {
    id: 12,
    name: SIDE_NAVIGATION_ITEM_NAMES.SESSION_HOSTS,
    routeOnClick: ROUTES.SESSION_HOSTS,
    isSelected: false,
  },
  {
    id: 10,
    name: SIDE_NAVIGATION_ITEM_NAMES.NOTIFICATIONS,
    routeOnClick: ROUTES.NOTIFICATIONS,
    isSelected: false,
  },
];

export const SIDE_NAVIGATION_END_ITEMS: Array<ISideNavigationItem> = [
  {
    id: 8,
    name: SIDE_NAVIGATION_ITEM_NAMES.SETTINGS,
    routeOnClick: ROUTES.SETTINGS,
    isSelected: false,
  },
  {
    id: 9,
    name: SIDE_NAVIGATION_ITEM_NAMES.HELP,
    isSelected: false,
  },
];

export const PASSWORD_PARAMETERS: Array<ITooltipValidationParams> = [
  {
    id: 1,
    satisfied: false,
    name: 'Be atleast 6 characters long',
  },
  {
    id: 2,
    satisfied: false,
    name: 'Have atleast one uppercase',
  },
  {
    id: 3,
    satisfied: false,
    name: 'Have atleast 1 number',
  },
];

export const URL_VALIDATION_PARAMETERS: ITooltipValidationParams[] = [
  {
    id: 1,
    satisfied: false,
    name: 'URLs must not contain spaces',
  },
];

export const BUTTON_LABEL_CONSTANTS = {
  ADD_APPLICATION: 'Add Application',
  DELETE_BUTTON_LABEL: 'Delete',
  CANCEL_BUTTON_LABEL: 'Cancel',
  ALLOW_ACCESS_BUTTON_LABEL: 'Allow Access',
  REMOVE_BUTTON_LABEL: 'Remove',
  SAVE_BUTTON_LABEL: 'Save',
  YES_BUTTON_LABEL: 'Yes',
  LEAVE_BUTTON_LABEL: 'Leave',
  DETACH_BUTTON_LABEL: 'Detach',
};

export const REGEX = {
  EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, //NOSONAR
  SPACE: /\s/,
  DIGIT: /\d/,
  UPPERCASE: /[A-Z]/,
  NUMBER: /^\d+$/,
  PHONE: /^[-\s\./0-9]*$/g,
  PORT: /^((6553[0-5])|(655[0-2][0-9])|(65[0-4][0-9]{2})|(6[0-4][0-9]{3})|([1-5][0-9]{4})|([0-5]{0,5})|([0-9]{1,4}))$/gi,
  SERVER_IP: /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
  DOMAIN_URL:
    '(https://)?(www.)?[a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)',
  IP_ADDRESS_URL: '^(https://)(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\\:((6553[0-5])|(655[0-2][0-9])|(65[0-4][0-9]{2})|(6[0-4][0-9]{3})|([1-5][0-9]{4})|([0-5]{0,5})|([0-9]{1,4})))?(\\/?).*'
};

export const USER_GROUPS_AND_APPS_HEADERS = (
  hideNoOfUsers?: boolean,
  onLabelClick?: () => void,
): ICell[] => {
  return [
    {
      value: <LabelWithIcon label="Name" path={DownArrowInactive} alt="sort" />,
      width: '75.68%',
      onClick: onLabelClick,
    },
    {
      value: hideNoOfUsers ? '' : 'No. Of Users',
      width: '12%',
    },
    {
      // TODO: Replace this when stats are ready
      value: '',
      // value: 'Stats',
    },
    // options
    {
      value: '',
    },
  ];
};
export const USERS_HEADERS: ICell[] = [
  {
    value: <LabelWithIcon label="Name" path={DownArrowInactive} alt="sort" />,
    width: '34%',
  },
  {
    value: 'Status',
    width: '16.82%',
  },
  {
    value: 'Groups',
    width: '36.86%',
  },
  {
    value: 'Stats',
  },
  // options
  {
    value: '',
  },
];

export const USERS_IN_GROUPS_HEADERS = [
  {
    value: <LabelWithIcon label="Name" path={DownArrowInactive} alt="sort" />,
    width: '28%',
  },
  {
    value: 'Status',
    width: '15%',
  },
  {
    value: 'Groups',
    width: '62%',
  },
];

export const TABLE_FIRST_ITEM_WIDTH = '8.4%';
export const USERGROUPS_APPS_TABLE_NAME_ITEM_WIDTH = '75.68%';
export const USERGROUPS_APPS_TABLE_GROUPS_WIDTH = '53.67%';
export const USERGROUPS_APPS_TABLE_NO_OF_USERS_WIDTH = '12%';
export const USERGROUPS_APPS_TABLE_ICONS_WIDTH = '5%';

export const LOGS_TABLE_ITEMS_WIDTH = {
  FIRST: '16.25%',
  REST_FIELDS: '10%',
  USER_ID: '13%',
  SEVERITY: '12%',
  COLLAPSE_ICON: '8%',
  APPLICATION: '12%',
  CATEGORY: '14%',
};

export const AVATAR_GROUP_MAX_SIZE = 5;

export const EMPTY_STATE_ICONS = {
  APPS_WITH_VIOLATIONS_ICON: AppsWithViolationsIcon,
  USERGROUP_WITH_VIOLATIONS_ICON: UserGroupWithViolationsIcon,
  VIOLATIONS_BY_CATEGORY_ICON: ViolationsByCategoryIcon,
  USER_LOGIN_ICON: UserLoginIcon,
  APPS_ACCESSED_ICON: AppsAccessedIcon,
  USERS_WITH_VIOLATIONS_ICON: UsersWithViolationsIcon,
  EVENTS_SEVERITY_ICON: EventsSeverityIcon,
};

export const AVATARS_SIZE = {
  small: 24,
  medium: 31,
  large: 38,
};
export const DROP_DOWN_ICON = 'Chevron down icon';
export const CHEVRON_UP_ICON = 'Chevron up icon';

export const CHIP_MAX_WIDTH = theme.spacing(39);

export const EMPTY_FUNCTION = () => {
  // EMPTY FUNCTION
};

export const APPLICATION_TYPE_OPTIONS: Array<IDropdownOptionProps> = [
  { id: 1, name: 'https' },
  { id: 2, name: 'http' },
  { id: 3, name: 'ssh' },
  { id: 4, name: 'rdp' },
  { id: 5, name: 'vnc' },
  // { id: 6, name: 'thickclient' },
];

export const PHONE_CODE_OPTIONS: Array<IDropdownOptionProps> = [
  { id: 12, name: '+1' },
  { id: 1, name: '+91' },
  { id: 2, name: '+55' },
  { id: 3, name: '+93' },
  { id: 4, name: '+685' },
  { id: 5, name: '+61' },
  { id: 6, name: '+49' },
  { id: 7, name: '+98' },
  { id: 8, name: '+94' },
  { id: 9, name: '+41' },
  { id: 10, name: '+379' },
  { id: 11, name: '+65' },
  { id: 13, name: '+32' },
  { id: 14, name: '+975' },
  { id: 15, name: '+236' },
  { id: 16, name: '+86' },
  { id: 17, name: '+57' },
  { id: 18, name: '+20' },
  { id: 19, name: '+372' },
  { id: 20, name: '+33' },
  { id: 21, name: '+81' },
];

// Application protocols are used by backend API.
export const APPLICATION_PROTOCOLS = {
  BROWSER_APP: 'browser-app',
  HTTP: 'http',
  SSH: 'ssh',
  RDP: 'rdp',
  VNC: 'vnc',
  THICKCLIENT_APP: 'thickclient-app',
};

export const SESSION_RECORDINGS_LIMIT = 100;

export const LOGS_LIMIT = 100;

export const NOTIFICATIONS_LIMIT = 100;

export const USER_STATUS_OPTIONS: Array<IDropdownOptionProps> = [
  { id: 1, name: 'Active' },
  { id: 2, name: 'Suspended' },
  { id: 3, name: 'Inactive' },
];

export const DOWNLOAD_FILE_FORMAT_OPTIONS: Array<IDropdownOptionProps> = [
  { id: 1, name: 'csv' },
  { id: 2, name: 'txt' },
  { id: 3, name: 'json' },
];

export const DOWNLOAD_FIELDS_OPTIONS: Array<IDropDownItem> = [
  { id: 'timestamp', name: 'Time stamp' },
  { id: 'userId', name: 'User ID' },
  { id: 'location', name: 'Location' },
  { id: 'sessionId', name: 'Session ID' },
  { id: 'severity', name: 'Severity' },
  { id: 'category', name: 'Category' },
  { id: 'description', name: 'Description' },
  { id: 'applicationName', name: 'Application Name' },
  { id: 'appType', name: 'Application Type' },
];

export const POLICY_PARAMETER_OPTIONS = [
  { id: 1, name: 'Geolocation' },
  { id: 2, name: 'Time of day' },
  { id: 3, name: 'Applications' },
  { id: 4, name: 'IP Address' },
  { id: 5, name: 'Url' },
];

export const POLICY_EQUATION_OPTIONS = [
  { id: 1, name: 'is equal to' },
  { id: 2, name: 'not equal to' },
];

export const POLICY_ALLOWANCE_OPTIONS = [
  { id: 1, name: 'Allow' },
  { id: 2, name: 'Deny' },
  { id: 3, name: 'Notify' },
  { id: 4, name: 'And' },
];

// If we get new app integrations, all we have to do is add 2 properties to these constants.
export const APP_IMAGE_MAP: StringToStringMap = {
  GITHUB: 'public/assets/GithubLogo.svg',
  GMAIL: 'public/assets/GmailLogo.svg',
  GOOGLE_DRIVE: 'public/assets/GoogleDriveLogo.svg',
  JIRA: 'public/assets/JiraLogo.svg',
  SLACK: 'public/assets/SlackLogo.svg',
  PAYPAL: 'public/assets/PaypalLogo.svg',
  AIRTABLE: 'public/assets/AirtableLogo.svg',
  DEFAULT: defaultAppIcon,
};

export const APP_DOMAIN_NAME_MAP: StringToStringMap = {
  GITHUB: 'github.com',
  GMAIL: 'mail.google.com',
  GOOGLE_DRIVE: 'drive.google.com',
  // TODO: How do we recognize JIRA and SLACK? Each organization is provided with different domain.
  JIRA: 'sonet.atlassian.com',
  SLACK: 'sonet.slack.com',
  PAYPAL: 'www.paypal.com',
  AIRTABLE: 'www.airtable.com',
};
export const USERS_TABLE_NAME_ITEM_WIDTH = '34%';
export const USERS_TABLE_STATUS_ITEM_WIDTH = '16.82%';
export const USERS_TABLE_GROUPS_ITEM_WIDTH = '36.86%';
export const USERS_TABLE_ICONS_WIDTH = '5%';

export const DRAGGABLE_POLICY__ITEMS_ID = {
  POLICY_BLOCK_ID: 'draggable-policy-block',
  POLICY_CONDITION_ID: 'draggable-policy-condition',
  POLICY_ACTION_ID: 'draggable-policy-action',
};

export const APP_LOGO_URL = {
  SLACK:
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS7u5feD054tj_vF2IR5Uk2nHs5bLFtAy4WXJ7bv8q1oNz9x4NPg4SR9lQzO9dqE5nUsas&usqp=CAU',
  JIRA:
    'https://cdn.icon-icons.com/icons2/2699/PNG/512/atlassian_jira_logo_icon_170511.png',
};

export const SELECT_APP_CARD = {
  MAX_CONTENT_LENGTH: 110,
  HEIGHT_OF_CONTENT_CONTAINER: '59px',
  LOGO_WIDTH: 66,
  LOGO_HEIGHT: 66,
  DEFAULT_LOGO: 'public/assets/app-logos.svg',
};

export const ACTIVE_SESSION_HEADERS_WIDTHS = {
  'checkBox': '5%',
  'name': '15%',
  'dateTime': '25%',
  'ipDeviceMetaData': '30%',
  'duration': '25%'
};

export const USERS_ACTIVITY_HEADERS = [
  {
    value: <LabelWithIcon label="Name" path={DownArrowInactive} alt="sort" />,
    width: '17.88%',
  },
  {
    value: 'Date & time',
    width: '11.77%',
  },
  {
    value: 'Application',
    width: '15.7%',
  },
  {
    value: 'Violations',
    width: '10.03%',
  },
  {
    value: 'Type Of Violation',
    width: '21.81%',
  },
  {
    value: 'Duration',
    width: '11.88%',
  },
];

export const POLICIES_HEADERS: ICell[] = [
  {
    value: <LabelWithIcon label="Name" path={DownArrowInactive} alt="sort" />,
    width: '24.80%',
  },
  {
    value: 'Associated Applications',
    width: '18.08%',
  },
  {
    value: 'Last Updated By',
    width: '16.46%',
  },
  {
    value: 'Last Policy Hit',
    width: '15.53%',
  },
  {
    value: 'Status',
    width: '11.01%',
  },
  {
    value: 'Stats',
  },
  // options
  {
    value: '',
  },
];

export const POLICIES_HEADERS_UNDER_USERGROUPS: ICell[] = [
  {
    value: <LabelWithIcon label="Name" path={DownArrowInactive} alt="sort" />,
    width: '29.44%',
  },
  {
    value: 'Associated Applications',
    width: '22.68%',
  },
  {
    value: 'Last Policy Hit',
    width: '22.24%',
  },
  {
    value: 'Status',
    width: '11.55%',
  },
  {
    value: 'Stats',
  },
  // options
  {
    value: '',
  },
];

export const POLICIES_HEADERS_UNDER_USERS: ICell[] = [
  {
    value: <LabelWithIcon label="Name" path={DownArrowInactive} alt="sort" />,
    width: '22.02%',
  },
  {
    value: 'Associated Groups',
    width: '20.71%',
  },
  {
    value: 'Associated Applications',
    width: '20.06%',
  },
  {
    value: 'Last Policy Hit',
    width: '12.10%',
  },
  {
    value: 'Status',
    width: '11.01%',
  },
  {
    value: 'Stats',
  },
  // options
  {
    value: '',
  },
];

export const POLICIES_TABLE_ICONS_WIDTH = '5%';

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const FULL_MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const USER_DETAILS_TAB = (hidePassword?: boolean, userRole?: string | null) => {
  return {
    NAME: {
      label: 'Name',
      value: '',
      buttonLabel: GLOBAL_LABELS.EDIT,
      showButton: false,
    },
    EMAIL: {
      label: 'Username',
      value: '',
      buttonLabel: GLOBAL_LABELS.EDIT,
      showButton: false,
    },
    JOB_TITLE: {
      label: 'Job Title',
      value: '',
      buttonLabel: GLOBAL_LABELS.EDIT,
      showButton: false,
    },
    PASSWORD: {
      label: 'Password',
      // Intentionally hardcoding password, as we need to show random number of masked chars
      value: '*************',
      buttonLabel: 'Change Password',
      showButton: false,
    },
    USER_STATUS: {
      label: 'User Status',
      value: '',
      showButton: false,
    },
    SOURCE: {
      label: 'Source',
      value: '',
      showButton: false,
    },
    ROLE: {
      label: 'Role',
      value: '',
      showButton: true,
    },
    CREATED_BY: {
      label: 'Created By',
      value: '',
      showButton: false,
    },
    CREATED_ON: {
      label: 'Created On',
      value: '',
      showButton: false,
    },
    DESCRIPTION: {
      label: 'Description',
      value: '',
      buttonLabel: GLOBAL_LABELS.EDIT,
      showButton: false,
    },
    SKIP_ONBOARDING: {
      label: 'Skip Onboarding',
      value: '',
      showButton: false,
    },
    DISABLE_MFA: {
      label: 'MFA Disabled',
      value: '',
      showButton: false,
    },
  };
};

export const MOCK_CURRENT_USER = {
  name: 'Andy R',
  organization: 'Admin-Hitech',
};

export interface IDashboardOverviewProps {
  id?: number;
  name: string;
  count: number;
  overviewItemicon: string;
  itemOverviewType?: 'positive' | 'negative' | 'neutral';
  variationCount?: number;
  tooltipData?: {
    hour_time?: string | null;
    users?: string[];
  };
}

export const USER_GROUP_DETAILS_TAB: IUserGroupDetailsTabType = {
  GROUP_NAME: {
    label: 'Group Name',
    value: '',
    buttonLabel: GLOBAL_LABELS.EDIT,
    showButton: false,
  },
  NUMBER_OF_USERS: {
    label: 'Number of Users',
    value: '',
    showButton: false,
  },
  CREATED_BY: {
    label: 'Created By',
    value: '',
    showButton: false,
  },
  DESCRIPTION: {
    label: 'Description',
    value: '',
    buttonLabel: GLOBAL_LABELS.EDIT,
    showButton: true,
  },
  SOURCE: {
    label: 'Source',
    value: '',
    showButton: false,
  },
  CREATED_ON: {
    label: 'Created On',
    value: '',
    showButton: false,
  },
};

const getCustomDomainLabel = (protocolType: string) => {
  if (protocolType === APPLICATION_PROTOCOLS.THICKCLIENT_APP) {
    return 'Application Launch Path';
  } else if (protocolType !== APPLICATION_PROTOCOLS.BROWSER_APP) {
    return 'Hostname';
  }
  return 'Launch Application URL'
}

export const APPLICATION_DETAILS_TAB = (protocolType: string) => {
  return {
    APP_NAME: {
      label: 'Name',
      value: '',
      buttonLabel: GLOBAL_LABELS.EDIT,
      showButton: false,
    },
    APP_ICON: {
      label: 'Application Logo',
      value: '',
      buttonLabel: GLOBAL_LABELS.EDIT,
      showButton: true,
    },
    CUSTOM_DOMAIN: {
      label: getCustomDomainLabel(protocolType),
      value: '',
      buttonLabel: GLOBAL_LABELS.EDIT,
      showButton: false,
    },
    RDP_APP_PATH: {
      label: 'Application Path',
      value: '',
      buttonLabel: GLOBAL_LABELS.EDIT,
      showButton: false,
    },
    IDP_APP_URL: {
      label: 'Application URL(s)',
      value: '',
      buttonLabel: GLOBAL_LABELS.EDIT,
      showButton: false,
    },
    DOMAIN_URL: {
      label: 'Domain Url(s)',
      value: '',
      buttonLabel: GLOBAL_LABELS.EDIT,
      showButton: true,
    },
    SOURCE: {
      label: 'Source',
      value: '',
      buttonLabel: GLOBAL_LABELS.EDIT,
      showButton: false,
    },
    CREATED_BY: {
      label: 'Created By',
      value: '',
      showButton: false,
    },
    CREATED_ON: {
      label: 'Created On',
      value: '',
      showButton: false,
    },
    DESCRIPTION: {
      label: 'Description',
      value: '',
      showButton: true,
      buttonLabel: GLOBAL_LABELS.EDIT,
    },
    APPLICATION_TYPE: {
      label: 'Protocol',
      value: '',
      buttonLabel: GLOBAL_LABELS.EDIT,
      showButton: false,
    },
    BOOKMARK_URL: {
      label: 'Bookmark URL',
      value: '',
      showButton: false,
    },
    EXTERNAL_APP_URL: {
      label: 'External App URL',
      value: '',
      showButton: false,
    },
    IS_EXTERNAL_APP: {
      label: 'Is External App',
      value: '',
      showButton: false,
    },
  };
};

export const USER_DETAILS_ACTIONS_MENU = {
  delete: {
    text: 'Delete',
    icon: deleteIcon,
    activeIcon: deleteIcon,
    isDanger: true,
  },
};

export const SAMPLE_USER_GROUP_RESPONSE: IListUserGroupsResponse = {
  identifier: 'hijk',
  attributes: {
    disabled: false,
    description: 'This is a mock description of hijk user group.',
  },
};
export const ACTIONS_TABLE_ROWS = [
  {
    text: 'Delete',
    icon: DeleteRedSvg,
    activeIcon: DeleteRedSvg,
    isDanger: true,
    handleClick: handleClickDropdownItem,
  },
];

export const ACTIONS_TABLE_ROWS_UNDER_TABS = [
  {
    text: 'Remove',
    icon: DeleteRedSvg,
    activeIcon: DeleteRedSvg,
    isDanger: true,
    handleClick: handleClickDropdownItem,
  },
];

// In graph we are displaying top 6 violations only, If we want to display more bars then add colors
export const getColorsForBars = [
  { color: '#005FC6' },
  { color: '#006EE5' },
  { color: '#308AEB' },
  { color: '#5CABFF' },
  { color: '#7ABAFF' },
  { color: '#92C6FF' },
  { color: '#B9DBFF' },
  { color: '#b6d7fa' },
];

// In category violations we are displaying top 10 violations only, If we want to display more violations then add colors
export const getColorsForCategoryWidget = [
  { color: EXTRA_COLORS.darkRed },
  { color: EXTRA_COLORS.darkRed_100 },
  { color: EXTRA_COLORS.darkRed_200 },
  { color: EXTRA_COLORS.red },
  { color: EXTRA_COLORS.red_100 },
  { color: theme.palette.error.main },
  { color: EXTRA_COLORS.mediumRed },
  { color: EXTRA_COLORS.mediumRedOrange },
  { color: EXTRA_COLORS.mediumOrange },
  { color: EXTRA_COLORS.lightRedOrange },
];

export const getColorsForSeverity = (name: string) => {
  if (name === 'Medium') {
    return { color: EXTRA_COLORS.orange, textColor: EXTRA_COLORS.orange };
  } else if (name === 'High') {
    return {
      color: EXTRA_COLORS.redishOrange,
      textColor: theme.palette.error.main,
    };
  } else if (name === 'Critical') {
    return {
      color: theme.palette.error.main,
      textColor: theme.palette.error.main,
    };
  } else if (name === 'Informational') {
    return { color: EXTRA_COLORS.accentBlue, textColor: EXTRA_COLORS.blue_200 };
  } else if (name === 'Low') {
    return {
      color: theme.palette.warning.main,
      textColor: EXTRA_COLORS.warning_300,
    };
  } else if (name === 'Warning') {
    return {
      color: EXTRA_COLORS.mediumRedOrange,
      textColor: EXTRA_COLORS.mediumRedOrange,
    };
  } else {
    return {
      // if severity is added in future this color is used
      color: '#77C7FF',
      textColor: '#77C7FF',
    };
  }
};

export const USER_ONBOARDING_PROGRESS_BAR_LABELS = [
  {
    id: '1',
    label: 'Set New Password',
  },
  {
    id: '2',
    label: 'Authentication Setup',
  },
  {
    id: '3',
    label: 'User Information',
  },
];

export const MOCK_APP_FIELDS = {
  CREATED_BY: 'Andy R',
  CREATED_ON: 'March 19 ,2021, 19:00 PM',
  CUSTOM_DOMAIN: 'https://www.demoapplicationurl.com',
  LOGO: 'https://cdn-icons-png.flaticon.com/512/25/25231.png',
  APP_NAME: 'Github',
};
export const TOKEN = 'token';
export const USER_ID = 'userId';
export const ROLE = 'role';
export const FULL_NAME = 'fullName';
export const ORGANIZATION = 'organization';
export const EMAIL = 'email';
export const SOURCE = 'source';
export const FIRST_TIME_LOGGEDIN = 'firstLogIn';
export const IDP_CONNECTION_ID = 'idpConnectionId';
export const MOCK_SEARCH_DATA = [
  'Ed Harris',
  'Google Drive',
  'Download',
  'Contractors in Estonia',
];

export const USER_ACTIVITY_TABLE_FIRST_ITEM_PADDING = 6;

export const EXPANDED_LOGS_KEYS = {
  Timestamp: '',
  'User Id': '',
  Location: '',
  Severity: '',
  Category: '',
  Description: '',
  'IP Address': '',
  Application: '',
  Browser: '',
  Violation: '',
  Output: '',
  'Policy Outcome': '',
  Message: '',
  'Application Type': '',
};

export const EXPANDED_NOTIFICATIONS_KEYS = {
  Message: '',
  Subject: '',
  Timestamp: '',
  Category: '',
  Severity: '',
  UserId: '',
  'Application Name': '',
};

export const EXPANDED_SESSION_KEYS = {
  //TODO: ADD THESE WHEN WE HAVE FIELDS IN API
  // Location: '',
  Duration: '',
  'Apps accessed during the session': '',
  // 'Files downloaded': '',
  // 'Files uploaded': '',
  // 'Total Bandwidth': '',
  'Policy Violations': '',
  Timezone: '',
};

export const REPORT_FIELDS_CHECKS = [
  { id: COLUMN_NAME.USERNAME, name: COLUMN_NAME.USERNAME, isChecked: false },
  { id: COLUMN_NAME.USER_GROUP, name: COLUMN_NAME.USER_GROUP, isChecked: false },
  { id: COLUMN_NAME.APP_START_TIME, name: COLUMN_NAME.APP_START_TIME, isChecked: false },
  { id: COLUMN_NAME.APP_END_TIME, name: COLUMN_NAME.APP_END_TIME, isChecked: false },
  { id: COLUMN_NAME.APP_DURATION, name: COLUMN_NAME.APP_DURATION, isChecked: false },
  { id: COLUMN_NAME.SESSION_START_TIME, name: COLUMN_NAME.SESSION_START_TIME, isChecked: false },
  { id: COLUMN_NAME.SESSION_END_TIME, name: COLUMN_NAME.SESSION_END_TIME, isChecked: false },
  { id: COLUMN_NAME.SESSION_DURATION, name: COLUMN_NAME.SESSION_DURATION, isChecked: false },
  { id: COLUMN_NAME.APPS, name: COLUMN_NAME.APPS, isChecked: false },
];

// taken as a base constant for all log check fields.
// Add new checks here when needed
export const LOG_FIELDS_CHECKS = [
  { id: 'timestamp', name: 'Time stamp', isChecked: false },
  { id: 'userId', name: 'User ID', isChecked: false },
  { id: 'location', name: 'Location', isChecked: false },
  { id: 'severity', name: 'Severity', isChecked: false },
  { id: 'category', name: 'Category', isChecked: false },
  { id: 'applicationName', name: 'Application Name', isChecked: false },
];
export const SAMPLE_LOG_ROW_DATA: ILogsTableRow = {
  timestamp: '',
  userId: '',
  location: '',
  severity: '',
  category: '',
  applicationName: '',
  ipAddress: '',
  browser: '',
  description: '',
  violation: '',
  output: '',
  policyOutcome: '',
  message: '',
  utcValue: '',
  applicationType: '',
};
export interface ILogTableDisplayFlag {
  TIMESTAMP: boolean;
  USERID: boolean;
  LOCATION: boolean;
  SESSIONID: boolean;
  SEVERITY: boolean;
  CATEGORY: boolean;
  DESCRIPTION: boolean;
  IPADDRESS: boolean;
  APPLICATION_NAME: boolean;
  BROWSER: boolean;
  VIOLATION: boolean;
  OUTPUT: boolean;
  POLICY_OUTCOME: boolean;
  MESSAGE: boolean;
  APPLICATION_TYPE: boolean;
}

export const ALL_USERS_GROUP = 'All Users';

export const ADMIN = 'superadmin';

export const SECONDARY_ADMIN = 'admin';

export const ACCOUNT_SETTING_LANGUAGE_OPTIONS: Array<IDropdownOptionProps> = [
  { id: 1, name: 'English' },
];

export const ACCOUNT_SETTING_TIMEZONE_OPTIONS: Array<IDropdownOptionProps> = [
  {
    id: 1,
    code: 'America/Los_Angeles',
    name: '(UTC -8:00) Pacific Time (US & Canada)',
  },
  {
    id: 2,
    code: 'America/Chicago',
    name: '(UTC -6:00) Central Time (US & Canada)',
  },
  {
    id: 3,
    code: 'America/New_York',
    name: '(UTC -5:00) Eastern Time (US & Canada)',
  },
  {
    id: 4,
    code: 'America/Denver',
    name: '(UTC -7:00) Mountain Time (US & Canada)',
  },
  {
    id: 5,
    code: 'Asia/Kolkata',
    name: '(UTC +5:30) Bombay, Calcutta, Madras, New Delhi',
  },
  {
    id: 6,
    code: 'Asia/Singapore',
    name: '(UTC +8:00) Beijing, Perth, Singapore, Hong Kong',
  },
  {
    id: 7,
    code: 'Asia/Tokyo',
    name: '(UTC +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk',
  },
  {
    id: 8,
    code: 'Europe/London',
    name: '(UTC +0:0) Western Europe Time, London, Lisbon, Casablanca',
  },
  {
    id: 9,
    code: 'Europe/Madrid',
    name: '(UTC +1:00) Brussels, Copenhagen, Madrid, Paris',
  },
  {
    id: 10,
    code: 'Asia/Baghdad',
    name: '(UTC +3:00) Baghdad, Riyadh, Moscow, St. Petersburg',
  },
  {
    id: 11,
    code: 'Etc/GMT+12',
    name: '(UTC -12:00) International Date Line West',
  },
  {
    id: 12,
    code: 'Pacific/Midway',
    name: '(UTC -11:00) Midway Island, Samoa',
  },
  {
    id: 13,
    code: 'Pacific/Honolulu',
    name: '(UTC -10:00) Hawaii',
  },
  {
    id: 14,
    code: 'US/Alaska',
    name: '(UTC -09:00) Alaska',
  },
  {
    id: 15,
    code: 'US/Arizona',
    name: '(UTC -07:00) Arizona',
  },
  {
    id: 16,
    code: 'America/Bogota',
    name: '(UTC -05:00) Bogota, Lima, Quito, Rio Branco',
  },
  {
    id: 17,
    code: 'Canada/Atlantic',
    name: '(UTC -04:00) Atlantic Time (Canada)',
  },
  {
    id: 18,
    code: 'America/Argentina/Buenos_Aires',
    name: '(UTC -03:00) Buenos Aires, Georgetown',
  },
  {
    id: 19,
    code: 'America/Noronha',
    name: '(UTC -02:00) Mid-Atlantic',
  },
  {
    id: 20,
    code: 'Atlantic/Azores',
    name: '(UTC -01:00) Azores',
  },
  {
    id: 21,
    code: 'Europe/Helsinki',
    name: '(UTC +02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
  },
  {
    id: 22,
    code: 'Asia/Tehran',
    name: '(UTC +03:30) Tehran',
  },
  {
    id: 23,
    code: 'Asia/Yerevan',
    name: '(UTC +04:00) Yerevan, Dubai',
  },
  {
    id: 24,
    code: 'Asia/Kabul',
    name: '(UTC +04:30) Kabul',
  },
  {
    id: 25,
    code: 'Asia/Yekaterinburg',
    name: '(UTC +05:00) Yekaterinburg',
  },
  {
    id: 26,
    code: 'Asia/Karachi',
    name: '(UTC +05:00) Islamabad, Karachi, Tashkent',
  },
  {
    id: 27,
    code: 'Asia/Katmandu',
    name: '(UTC +05:45) Kathmandu',
  },
  {
    id: 28,
    code: 'Asia/Dhaka',
    name: '(UTC +06:00) Astana, Dhaka',
  },
  {
    id: 29,
    code: 'Asia/Rangoon',
    name: '(UTC +06:30) Yangon (Rangoon)',
  },
  {
    id: 30,
    code: 'Asia/Bangkok',
    name: '(UTC +07:00) Bangkok, Hanoi, Jakarta',
  },
  {
    id: 31,
    code: 'Australia/Adelaide',
    name: '(UTC +09:30) Adelaide',
  },
  {
    id: 32,
    code: 'Australia/Canberra',
    name: '(UTC +10:00) Canberra, Melbourne, Sydney',
  },
  {
    id: 33,
    code: 'Asia/Magadan',
    name: '(UTC +11:00) Magadan, Solomon Is., New Caledonia',
  },
  {
    id: 34,
    code: 'Pacific/Auckland',
    name: '(UTC +12:00) Auckland, Wellington',
  },
  {
    id: 35,
    code: 'Pacific/Tongatapu',
    name: "(UTC +13:00) Nuku'alofa",
  },
];

export const TIME_ZONE_MAP: any = {
  '(UTC -8:00) Pacific Time (US & Canada)': 'America/Los_Angeles',
  '(UTC -6:00) Central Time (US & Canada)': 'America/Chicago',
  '(UTC -5:00) Eastern Time (US & Canada)': 'America/New_York',
  '(UTC -7:00) Mountain Time (US & Canada)': 'America/Denver',
  '(UTC +5:30) Bombay, Calcutta, Madras, New Delhi': 'Asia/Kolkata',
  '(UTC +8:00) Beijing, Perth, Singapore, Hong Kong': 'Asia/Singapore',
  '(UTC +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk': 'Asia/Tokyo',
  '(UTC +0:0) Western Europe Time, London, Lisbon, Casablanca': 'Europe/London',
  '(UTC +1:00) Brussels, Copenhagen, Madrid, Paris': 'Europe/Madrid',
  '(UTC +3:00) Baghdad, Riyadh, Moscow, St. Petersburg': 'Asia/Baghdad',
  '(UTC -12:00) International Date Line West': 'Etc/GMT+12',
  '(UTC -11:00) Midway Island, Samoa': 'Pacific/Midway',
  '(UTC -10:00) Hawaii': 'Pacific/Honolulu',
  '(UTC -09:00) Alaska': 'US/Alaska',
  '(UTC -07:00) Arizona': 'US/Arizona',
  '(UTC -05:00) Bogota, Lima, Quito, Rio Branco': 'America/Bogota',
  '(UTC -04:00) Atlantic Time (Canada)': 'Canada/Atlantic',
  '(UTC -03:00) Buenos Aires, Georgetown': 'America/Argentina/Buenos_Aires',
  '(UTC -02:00) Mid-Atlantic': 'America/Noronha',
  '(UTC -01:00) Azores': 'Atlantic/Azores',
  '(UTC +02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius':
    'Europe/Helsinki',
  '(UTC +03:30) Tehran': 'Asia/Tehran',
  '(UTC +04:00) Yerevan, Dubai': 'Asia/Yerevan',
  '(UTC +04:30) Kabul': 'Asia/Kabul',
  '(UTC +05:00) Yekaterinburg': 'Asia/Yekaterinburg',
  '(UTC +05:00) Islamabad, Karachi, Tashkent': 'Asia/Karachi',
  '(UTC +05:45) Kathmandu': 'Asia/Katmandu',
  '(UTC +06:00) Astana, Dhaka': 'Asia/Dhaka',
  '(UTC +06:30) Yangon (Rangoon)': 'Asia/Rangoon',
  '(UTC +07:00) Bangkok, Hanoi, Jakarta': 'Asia/Bangkok',
  '(UTC +09:30) Adelaide': 'Australia/Adelaide',
  '(UTC +10:00) Canberra, Melbourne, Sydney': 'Australia/Canberra',
  '(UTC +11:00) Magadan, Solomon Is., New Caledonia': 'Asia/Magadan',
  '(UTC +12:00) Auckland, Wellington': 'Pacific/Auckland',
  "(UTC +13:00) Nuku'alofa": 'Pacific/Tongatapu',
};

const tzList = {
  'Etc/GMT+12': '(GMT-12:00) International Date Line West',
  'Pacific/Midway': '(GMT-11:00) Midway Island, Samoa',
  'Pacific/Honolulu': '(GMT-10:00) Hawaii',
  'US/Alaska': '(GMT-09:00) Alaska',
  'America/Los_Angeles': '(GMT-08:00) Pacific Time (US & Canada)',
  'US/Arizona': '(GMT-07:00) Arizona',
  'America/Managua': '(GMT-06:00) Central America',
  'US/Central': '(GMT-06:00) Central Time (US & Canada)',
  'America/Bogota': '(GMT-05:00) Bogota, Lima, Quito, Rio Branco',
  'US/Eastern': '(GMT-05:00) Eastern Time (US & Canada)',
  'Canada/Atlantic': '(GMT-04:00) Atlantic Time (Canada)',
  'America/Argentina/Buenos_Aires': '(GMT-03:00) Buenos Aires, Georgetown',
  'America/Noronha': '(GMT-02:00) Mid-Atlantic',
  'Atlantic/Azores': '(GMT-01:00) Azores',
  'Etc/Greenwich':
    '(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London',
  'Europe/Amsterdam':
    '(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
  'Europe/Helsinki':
    '(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
  'Europe/Moscow': '(GMT+03:00) Moscow, St. Petersburg, Volgograd',
  'Asia/Tehran': '(GMT+03:30) Tehran',
  'Asia/Yerevan': '(UTC +04:00) Yerevan, Dubai',
  'Asia/Kabul': '(GMT+04:30) Kabul',
  'Asia/Yekaterinburg': '(GMT+05:00) Yekaterinburg',
  'Asia/Karachi': '(GMT+05:00) Islamabad, Karachi, Tashkent',
  'Asia/Calcutta': '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
  'Asia/Katmandu': '(GMT+05:45) Kathmandu',
  'Asia/Dhaka': '(GMT+06:00) Astana, Dhaka',
  'Asia/Rangoon': '(GMT+06:30) Yangon (Rangoon)',
  'Asia/Bangkok': '(GMT+07:00) Bangkok, Hanoi, Jakarta',
  'Asia/Hong_Kong': '(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
  'Asia/Seoul': '(GMT+09:00) Seoul',
  'Australia/Adelaide': '(GMT+09:30) Adelaide',
  'Australia/Canberra': '(GMT+10:00) Canberra, Melbourne, Sydney',
  'Asia/Magadan': '(GMT+11:00) Magadan, Solomon Is., New Caledonia',
  'Pacific/Auckland': '(GMT+12:00) Auckland, Wellington',
  'Pacific/Tongatapu': "(GMT+13:00) Nuku'alofa",
};

export const POPUP_STYLE = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};
export const ROTATION_PERIOD_OPTIONS: Array<IDropdownOptionProps> = [
  { id: 1, name: 'Day' },
  { id: 2, name: 'Week' },
  { id: 3, name: 'Month' },
  { id: 4, name: 'Year' },
];

export const SESSION_RECORDING_SETTINGS_MOCK_DATA: ISessionRecordingSettingsResponse = {
  administratorUserSessionsEnabled: true,
  saveCredsAllowed: true,
  userSessionsPerPage: 100,
  authenticationTimeout: 60,
  rotationPeriod: {
    time: 7,
    diskSpace: null,
  },
  retentionPeriod: '90',
};

export const NOTIFICATION_SETTINGS_MOCK_DATA: INotificationSettingsResponse = {
  administratorNotifications: [
    {
      userId: 'ed.harris',
      fullName: 'Ed Harris',
      userName: 'ed.harris@acme.com',
      notificationType: 'Policy Vioaltions',
      notificationDetail: [
        { id: 'Critical', name: 'Critical' },
        { id: 'Informational', name: 'Informational' },
      ],
      notificationEnabled: true,
    },
  ],
  userNotificationsEnabled: true,
};

export const POLICY_ACTION_DROPDOWN_OPTIONS: Array<IDropDownItem> = [
  { id: '1', name: 'Allow' },
  { id: '2', name: 'Deny' },
  { id: '3', name: 'Notify' },
  { id: '4', name: 'And' },
];

export const MOCK_POLICIES: IListPolicyResponse[] = [
  {
    id: '1',
    policyName: 'Contractor Access',
    createdBy: 'Andy R',
    applications: ['Jira'],
    lastUpdatedBy: 'Andy R',
    lastUpdated: '2021-11-11T16:35:00',
    lastPolicyHitTime: '2021-11-11T16:35:00',
    policyStatus: 'active',
  },
  {
    id: '2',
    policyName: 'Developer Access',
    createdBy: 'Andy R',
    applications: ['Github'],
    lastUpdatedBy: 'Andy R',
    lastUpdated: '2021-11-08T18:35:00',
    lastPolicyHitTime: '2021-11-08T14:35:00',
    policyStatus: 'inactive',
  },
  {
    id: '3',
    policyName: 'Google Drive Access',
    createdBy: 'Andy R',
    applications: ['Drive'],
    lastUpdatedBy: 'Andy R',
    lastUpdated: '2021-11-12T15:35:00',
    lastPolicyHitTime: '2021-05-21T21:35:00',
    policyStatus: 'inactive',
  },
  {
    id: '4',
    policyName: 'Jira Access',
    createdBy: 'Andy R',
    applications: ['Github', 'Jira', 'Slack', 'Drive'],
    lastUpdatedBy: 'Andy R',
    lastUpdated: '2021-11-12T15:35:00',
    lastPolicyHitTime: '2021-11-11T16:35:00',
    policyStatus: 'active',
  },
  {
    id: '5',
    policyName: 'Slack Access',
    createdBy: 'Andy R',
    applications: ['Slack'],
    lastUpdatedBy: 'Andy R',
    lastUpdated: '2021-11-08T16:35:00',
    lastPolicyHitTime: '2021-11-08T14:35:00',
    policyStatus: 'active',
  },
  {
    id: '6',
    policyName: 'SSH Access Policy',
    createdBy: 'Andy R',
    applications: ['Dev Machine'],
    lastUpdatedBy: 'Andy R',
    lastUpdated: '2021-11-09T12:14:00',
    lastPolicyHitTime: '2021-11-10T09:24:00',
    policyStatus: 'inactive',
  },
  {
    id: '7',
    policyName: 'VNC Access Policy',
    createdBy: 'Andy R',
    applications: ['Jira', 'Github'],
    lastUpdatedBy: 'Andy R',
    lastUpdated: '2021-11-09T11:35:00',
    lastPolicyHitTime: '2021-11-09T14:35:00',
    policyStatus: 'active',
  },
];

export const FREQUENCY_DROPDOWN_OPTIONS: Array<IDropdownOptionProps> = [
  { id: 1, name: '1 hour' },
  { id: 2, name: '2 hour' },
  { id: 3, name: '3 hour' },
  { id: 4, name: '4 hour' },
];

export const USERROLE_DROPDOWN_OPTIONS: Array<IDropdownOptionProps> = [
  { id: 1, name: 'Admin' }
];

export const LOG_SERVER_FORM_DEFAULT_STATE: ILogServerResponse = {
  serverIP: '',
  port: 0,
  frequencyRange: '1 hour',
  active: true,
};

export const EDIT_ADMINISTRATOR_MODAL_DEFAULT_STATE: IAdministratorNotificationsDetail = {
  userId: '',
  fullName: '',
  userName: '',
  notificationDetail: [],
  notificationEnabled: true,
};

export const MOCK_POLICY_PANEL_RESPONSE = [
  {
    name: 'Sonet Login',
    type: 'default',
    defaultAction: 'Allow',
    conditionList: [],
  },
  {
    name: 'App Connect',
    type: 'default',
    defaultAction: 'Deny',
    conditionList: [],
  },
  {
    name: 'Content Inspection',
    type: 'default',
    defaultAction: 'Allow',
    conditionList: [],
  },
];

export const ALLOWED_IMAGE_FILE_TYPES = [
  'png',
  'jpg',
  'jpeg',
  'svg',
  'svg+xml',
  'gif',
  'webp',
  'bmp',
]

export const ALLOWED_FILE_TYPES = [
  ...ALLOWED_IMAGE_FILE_TYPES,
  'json',
  'x-x509-ca-cert',
];

export const MAX_FILE_SIZE_UPLOAD = 20000000;
export const MAX_APP_ICON_FILE_SIZE = 50000;
export const MAX_ORGANIZATION_LOGO_SIZE = 5242880;

export const GREY_OUT_OVERVIEW_ITEMS = [
  'Number Of Logins',
  'Uploads',
  'Download',
];

export const BASE64_STRING_LENGTH = 65000;

export const ADMIN_FORM_ROLE_OPTIONS: Array<IDropdownOptionProps> = [
  { id: 1, name: 'Super Admin' },
];

export const EXPIRATION_STATUS = ['on ', ' day(s) left'];

export const LICENSE_PLAN_ICONS = {
  TRY_AND_BUY: ['Try & Buy', TryAndBuyPricing],
  STANDARD: ['Standard', StandardPricing],
  ADVANCED: ['Advanced', AdvancedPricing],
  ENTERPRISE: ['Enterprise', EnterprisePricing],
};

export const HIDE_ADD_LIST_ITEM_IN_POLICY = true;

/**
 * Added by devang as a reference data
 */
export const ADDON_CATEGORY = {
  STORAGE: 'Storage',
  BANDWIDTH: 'Bandwidth',
  BEHAVIOURAL_ANALYTICS: 'Behavioural_Analytics',
  CONTENT_INSPECTION: 'Content_inspection',
};

export const PLAN_TYPE = {
  STANDARD: 'Standard Yearly Plan',
  ADVANCED: 'Advanced Yearly Plan',
  ENTERPRISE: 'Enterprise Yearly Plan',
  TRY_BUY: 'Trial & Buy',
};

export const LOGS_SEVERITY = [
  'Medium',
  'High',
  'Critical',
  'Informational',
  'Low',
  'Error',
];

export const LOGS_CATEGORY = [
  'Portal Login',
  'Application Access',
  'Data Import',
  'Policy Evaluation',
  'Access Denied',
  'Content Inspection',
  'Download Content',
  'Upload Content',
  'Ip Address',
  'File Access',
  'Edit Access',
  'Request Access',
  'Login Restriction',
];

export const SUBSCRIPTION_PLANS = [
  {
    planId: 'Enterprise-Yearly-Plan',
    price: 7500000,
    name: 'Enterprise Yearly Plan',
    icon: '',
    features: [
      'Access Control',
      'IdP Integration',
      'Logging',
      'Includes Content \nInspection Policies',
      'Unlimited Applications',
      'Session Recordings (Total\nStorage)',
      '100 GB storage',
      'Content Inspection(DLP)',
      'Behavioral Analytics',
    ],
    isCurrentPlan: false,
    availableAddons: [
      {
        id: 'Additional-Bandwidth',
        name: 'Additional Bandwidth',
        description: 'Additional Bandwidth is available for all plans',
        isQuantifiable: true,
      },
      {
        id: 'Additional-User',
        name: 'Additional User',
        description:
          'Additional Users can be added to any plan, max limit being 500',
        isQuantifiable: true,
      },
      {
        id: 'Additional-Storage',
        name: 'Additional Storage',
        description: '100 GB Additional Storage',
        isQuantifiable: true,
      },
    ],
  },
  {
    planId: 'Advanced-Yearly-Plan',
    price: 5000000,
    name: 'Advanced Yearly Plan',
    icon: '',
    features: [
      'Access Control',
      'IdP Integration',
      'Logging',
      'Includes Content \nInspection Policies',
      'Unlimited Applications',
      'Session Recordings (1 GB)',
      '5 GB storage',
      'Content Inspection(DLP)',
    ],
    isCurrentPlan: true,
    availableAddons: [
      {
        id: 'Additional-Bandwidth',
        name: 'Additional Bandwidth',
        description: 'Additional Bandwidth is available for all plans',
        isQuantifiable: true,
      },
      {
        id: 'Additional-User',
        name: 'Additional User',
        description:
          'Additional Users can be added to any plan, max limit being 500',
        isQuantifiable: true,
      },
      {
        id: 'AI-ML',
        name: 'AI / ML',
        description:
          'AI/ML is available for Standard and Advanced Subscriptions',
        isQuantifiable: false,
      },
      {
        id: 'Additional-Storage',
        name: 'Additional Storage',
        description: '100 GB Additional Storage',
        isQuantifiable: true,
      },
    ],
  },
  {
    planId: 'Standard-Yearly-Plan',
    price: 5000000,
    name: 'Standard Yearly Plan',
    icon: '',
    features: [
      'Upto 500 Users',
      'Access Control',
      'Includes Content \nInspection Policies',
      'Logging',
      'Limited Policy(No content)',
      'Unlimited',
      '1 GB storage',
      'Session Recordings (1 GB)',
      'Content Inspection(DLP)',
    ],
    isCurrentPlan: false,
    availableAddons: [
      {
        id: 'Additional-Bandwidth',
        name: 'Additional Bandwidth',
        description: 'Additional Bandwidth is available for all plans',
        isQuantifiable: true,
      },
      {
        id: 'DLP',
        name: 'DLP',
        description: 'Available for Standard Subscription',
        isQuantifiable: false,
      },
      {
        id: 'Additional-User',
        name: 'Additional User',
        description:
          'Additional Users can be added to any plan, max limit being 500',
        isQuantifiable: true,
      },
      {
        id: 'AI-ML',
        name: 'AI / ML',
        description:
          'AI/ML is available for Standard and Advanced Subscriptions',
        isQuantifiable: false,
      },
      {
        id: 'Additional-Storage',
        name: 'Additional Storage',
        description: '100 GB Additional Storage',
        isQuantifiable: true,
      },
    ],
  },
  {
    planId: 'Trial-Buy',
    price: 0,
    name: 'Trial & Buy',
    icon: '',
    features: [
      'Upto 10 Users',
      'Access Control',
      'IdP Integration(Limited)',
      'Logging',
      'Limited Policy(No content)',
      'Unlimited',
      '1 GB storage',
      'Session Recordings (1 GB)',
      'Content Inspection(DLP)',
    ],
    isCurrentPlan: false,
    availableAddons: [],
  },
];

export const CURRENT_SUB_PLAN = {
  planId: 'Advanced-Yearly-Plan',
  minUsers: 50,
  maxUsers: 1000,
  availableUsers: 91,
  storage: 959,
  bandwidth: 2115,
  addOns: [
    {
      id: 'Additional-Bandwidth',
      name: 'Additional Bandwidth',
      description: 'Additional Bandwidth is available for all plans',
      isQuantifiable: true,
    },
    {
      id: 'Additional-User',
      name: 'Additional User',
      description:
        'Additional Users can be added to any plan, max limit being 500',
      isQuantifiable: true,
    },
    {
      id: 'Additional-Storage',
      name: 'Additional Storage',
      description: '100 GB Additional Storage',
      isQuantifiable: true,
    },
  ],
  expirationDate: '2023-04-08T05:29:52.000+00:00',
};

export const NOTIFICATION_TABLE_FIRST_ITEM_WIDTH = '3.5%';

export enum IDP_TYPE {
  OKTA = 'okta'
};

/***
 * NOTE
 * This is a temporary rule to redirect login page for vendor fool.
 * This is gonna be replaced with a better design
 */

export const LOGIN_HARD_REDIRECTS = {
  ["fool.sonet.io"]: "https://motleyfool.oktapreview.com",
  ["devint.sonet.io"]: "https://sonet.okta.com",
}
export const GOOGLE_ICON_BASE_64 = 'data:image/svg+xml;base64,PHN2Zw0KICB3aWR0aD0iMTAwJSINCiAgaGVpZ2h0PSIxMDAlIg0KICB2aWV3Qm94PSIwIDAgMjQgMjQiDQogIGZpbGw9Im5vbmUiDQogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyINCj4NCiAgPHBhdGgNCiAgICBkPSJNNiAxMkM2IDE1LjMxMzcgOC42ODYyOSAxOCAxMiAxOEMxNC42MTI0IDE4IDE2LjgzNDkgMTYuMzMwNCAxNy42NTg2IDE0SDEyVjEwSDIxLjgwNDdWMTRIMjEuOEMyMC44NzM0IDE4LjU2NDUgMTYuODM3OSAyMiAxMiAyMkM2LjQ3NzE1IDIyIDIgMTcuNTIyOCAyIDEyQzIgNi40NzcxNSA2LjQ3NzE1IDIgMTIgMkMxNS40NDUgMiAxOC40ODMxIDMuNzQyIDIwLjI4MTUgNi4zOTMxOEwxNy4wMDM5IDguNjg4MTVDMTUuOTI5NiA3LjA2ODEyIDE0LjA4OTUgNiAxMiA2QzguNjg2MjkgNiA2IDguNjg2MjkgNiAxMloiDQogICAgZmlsbD0iY3VycmVudENvbG9yIg0KICAvPg0KPC9zdmc+';
export const OKTA_ICON_BASE_64 = 'data:image/jpeg;base64,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'
